import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";

export default function RequireAuth({ allowedRoles }: any) {
  const { auth }: any = useAuth();
  const { roles }: any = useAuth();
  const location = useLocation();
  console.log([allowedRoles, roles])
  
  const isAllowed = auth && roles?.some((role: any) => allowedRoles?.includes(role));
  
  if (isAllowed) {
    return <Outlet />
  }
  
  if (auth) {
    // Якщо авторизований, але не має доступу — редіректимо залежно від ролі
    const isTester = roles?.includes(11); // PanelUserAccessScope.TESTER = 11
    const isDeployer = roles?.includes(10); // PanelUserAccessScope.DEPLOYER = 10
    
    if (isTester) {
      return <Navigate to="/apps" replace />
    }
    if (isDeployer) {
      return <Navigate to="/domains" replace />
    }
    
    // Для інших ролей — на домени за замовчуванням
    return <Navigate to="/domains" replace />
  }
  
  return <Navigate to="/auth" state={{ from: location }} replace />
}
